import React from 'react';
import { Award, Star } from 'lucide-react';
import { Review } from '../utils/data';
interface ReviewCardProps {
  review: Review;
}
const ReviewCard: React.FC<ReviewCardProps> = ({
  review
}) => {
  const formattedDate = new Date(review.date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-100" data-id="element-69">
      <div className="flex items-start" data-id="element-70">
        <div className="flex-shrink-0 mr-3" data-id="element-71">
          <div className="h-10 w-10 rounded-full bg-brand-100 flex items-center justify-center" data-id="element-72">
            <Award className="h-6 w-6 text-brand-600" data-id="element-73" />
          </div>
        </div>
        <div data-id="element-74">
          <h4 className="font-medium text-gray-900" data-id="element-75">{review.dietitianName}</h4>
          <p className="text-xs text-gray-500" data-id="element-76">{review.credentials}</p>
          <div className="flex items-center mt-1 mb-2" data-id="element-77">
            {[...Array(5)].map((_, i) => <Star key={i} className={`h-4 w-4 ${i < review.rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} data-id="element-78" />)}
            <span className="text-xs text-gray-500 ml-2" data-id="element-79">{formattedDate}</span>
          </div>
          <p className="text-sm text-gray-600" data-id="element-80">{review.comment}</p>
        </div>
      </div>
    </div>;
};
export default ReviewCard;